/**
 * OP Progress Scales: Coordination Test (CT) includes `action`, which can bypass generic validation.
 * Validate explicitly: any option selected (intact/impaired) or comments filled.
 */
export const isCtScaleKey = (scaleKey) => {
  if (typeof scaleKey !== "string") return false;
  const k = scaleKey.trim();
  return k === "CT" || k.toLowerCase() === "coordinationtest" || k.toLowerCase() === "coordination";
};

const CT_KEYS = [
  "finger_to_nose",
  "finger_to_finger",
  "adiadochokinesia_or_dysdiadokokinesia",
  "rebound_phenomenon",
  "walking_along_straight_line",
  "rombergs_test",
  "heel_to_shin",
];

export const hasCtAssessmentInput = (data) => {
  if (!data || typeof data !== "object") return false;

  if (String(data.comments ?? "").trim().length > 0) return true;

  return CT_KEYS.some((k) => {
    const v = data[k];
    if (v == null) return false;
    if (typeof v === "string") return v.trim() !== "";
    return false;
  });
};

